import { useEffect, useState } from "react";

/**
 * The current `Date.now()`, read on every render, with a re-render forced
 * every `intervalMs` so a countdown flips without a reload. Reading the clock
 * at render (rather than storing it on the tick) keeps a fresh payload, such
 * as a refetch after an invitation is sent, on the current time instead of
 * the last tick's.
 */
export function useNow(intervalMs: number): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return Date.now();
}
